module.exports = __webpack_public_path__ + "img/FRUSTRATED.0b9908cd.png";